
import { computed, defineComponent, ref } from "vue";
import { useStore } from 'vuex';
import { Helper } from "@/utils/Helper";

export default defineComponent({
  name: 'tokensListTokenBoxComponent',
  props: ["item", "network", "otherNetworkItem"],
  setup(props){
    const store = useStore();
    const assetUrl = computed(() => {
      return store.getters['config/assetUrl'];
    });

    const testnetLabel = computed(() => {
      return store.getters['config/configTestnetLabel'];
    });

    const flip = ref(false);

    // const isMainnet = computed(() => {
    //   return props.mainnetGameTitles.includes(props.item.title);
    // });

    const param = computed(() => {
      return {testnetTokenId: props.network=='testnet'?props.item.tokenId:(props.otherNetworkItem?props.otherNetworkItem.tokenId:'-'), mainnetTokenId: props.network=='testnet'?(props.otherNetworkItem?props.otherNetworkItem.tokenId:''):props.item.tokenId };
    });

    return {
      param,
      assetUrl,
      testnetLabel,
      flip,
      Helper,
      // isMainnet,
    }
   }
});
